module.exports = "pegasus_template/assets/themecapture1/large/40.png";